(function () {
  'use strict';

  function initCustomPrinting(root) {
    if (!root || root.dataset.cpInitialized === 'true') return;
    root.dataset.cpInitialized = 'true';

    var maxFileSizeMB = parseFloat(root.dataset.maxFileSize) || 10;
    var garmentOptions = root.querySelectorAll('[data-garment-option]');
    var garmentViews = root.querySelectorAll('[data-garment-view]');
    var colorLists = root.querySelectorAll('[data-color-list]');
    var sideButtons = root.querySelectorAll('[data-side-btn]');
    var uploadZone = root.querySelector('[data-upload-zone]');
    var uploadInput = root.querySelector('[data-design-upload]');
    var uploadText = root.querySelector('[data-upload-text]');
    var uploadError = root.querySelector('[data-upload-error]');
    var designControls = root.querySelector('[data-design-controls]');
    var scaleInput = root.querySelector('[data-design-scale]');
    var removeBtn = root.querySelector('[data-remove-design]');
    var areaHint = root.querySelector('[data-area-hint]');
    var fieldGarment = root.querySelector('[data-field-garment]');
    var fieldColor = root.querySelector('[data-field-color]');
    var fieldFilename = root.querySelector('[data-field-filename]');
    var fieldPlacement = root.querySelector('[data-field-placement]');
    var colorLabel = root.querySelector('[data-selected-color-label]');
    var defaultUploadText = uploadText ? uploadText.textContent : '';

    function blankSide() {
      return { loaded: false, src: '', name: '', scale: 0.45, x: 0.5, y: 0.35 };
    }

    var state = {
      garmentId: garmentOptions.length ? garmentOptions[0].dataset.garmentOption : null,
      activeSide: 'front',
      sides: { front: blankSide(), back: blankSide() }
    };

    function side() {
      return state.sides[state.activeSide];
    }

    function anyDesign() {
      return state.sides.front.loaded || state.sides.back.loaded;
    }

    function updateGarmentField() {
      var option = root.querySelector('[data-garment-option="' + state.garmentId + '"]');
      if (fieldGarment && option) {
        var name = option.dataset.garmentName || '';
        var price = option.dataset.garmentPrice || '';
        fieldGarment.value = price ? name + ' (' + price + ')' : name;
      }
    }

    function updatePlacementField() {
      if (!fieldPlacement) return;
      var parts = [];
      ['front', 'back'].forEach(function (key) {
        var s = state.sides[key];
        if (s.loaded) {
          parts.push(
            key.charAt(0).toUpperCase() + key.slice(1) + ': "' + s.name + '" at ' +
            Math.round(s.x * 100) + '% across, ' + Math.round(s.y * 100) + '% down, width ' +
            Math.round(s.scale * 100) + '% of garment'
          );
        }
      });
      fieldPlacement.value = parts.length ? parts.join(' | ') : 'No design placed in preview';
    }

    function updateFilenameField() {
      if (!fieldFilename) return;
      var names = [];
      if (state.sides.front.loaded) names.push('Front: ' + state.sides.front.name);
      if (state.sides.back.loaded) names.push('Back: ' + state.sides.back.name);
      fieldFilename.value = names.join(' | ');
    }

    function activeColorButton() {
      var list = root.querySelector('[data-color-list="' + state.garmentId + '"]');
      return list ? list.querySelector('[data-color-option].is-active') : null;
    }

    function applyColor() {
      var btn = activeColorButton();
      var view = root.querySelector('[data-garment-view="' + state.garmentId + '"]');
      if (!btn) {
        if (fieldColor) fieldColor.value = '';
        if (colorLabel) colorLabel.textContent = '—';
        return;
      }
      if (fieldColor) fieldColor.value = btn.dataset.colorName || '';
      if (colorLabel) colorLabel.textContent = btn.dataset.colorName || '';
      if (view) {
        view.querySelectorAll('[data-garment-svg]').forEach(function (svgWrap) {
          svgWrap.style.color = btn.dataset.colorValue || '';
        });
      }
    }

    function renderDesigns() {
      garmentViews.forEach(function (view) {
        view.querySelectorAll('[data-design-layer]').forEach(function (layer) {
          var s = state.sides[layer.dataset.side];
          var img = layer.querySelector('[data-design-image]');
          if (!img || !s) return;
          if (!s.loaded) {
            img.hidden = true;
            img.removeAttribute('src');
            layer.classList.remove('has-design');
            return;
          }
          if (img.getAttribute('src') !== s.src) img.src = s.src;
          img.hidden = false;
          layer.classList.add('has-design');
          img.style.width = s.scale * 100 + '%';
          img.style.left = s.x * 100 + '%';
          img.style.top = s.y * 100 + '%';
        });
      });
      if (designControls) designControls.hidden = !side().loaded;
      if (scaleInput && side().loaded) scaleInput.value = Math.round(side().scale * 100);
      if (areaHint) areaHint.hidden = anyDesign();
      updatePlacementField();
      updateFilenameField();
    }

    function setSide(sideName) {
      state.activeSide = sideName;
      sideButtons.forEach(function (b) {
        b.classList.toggle('is-active', b.dataset.sideBtn === sideName);
      });
      garmentViews.forEach(function (view) {
        view.querySelectorAll('[data-side-view]').forEach(function (v) {
          v.classList.toggle('is-active', v.dataset.sideView === sideName);
        });
      });
      renderDesigns();
    }

    sideButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setSide(btn.dataset.sideBtn);
      });
    });

    garmentOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        state.garmentId = option.dataset.garmentOption;
        garmentOptions.forEach(function (o) {
          o.classList.toggle('is-active', o === option);
        });
        garmentViews.forEach(function (v) {
          v.classList.toggle('is-active', v.dataset.garmentView === state.garmentId);
        });
        colorLists.forEach(function (l) {
          l.classList.toggle('is-active', l.dataset.colorList === state.garmentId);
        });
        updateGarmentField();
        applyColor();
        renderDesigns();
      });
    });

    colorLists.forEach(function (list) {
      list.querySelectorAll('[data-color-option]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          list.querySelectorAll('[data-color-option]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          applyColor();
        });
      });
    });

    function showUploadError(message) {
      if (!uploadError) return;
      uploadError.textContent = message;
      uploadError.hidden = !message;
    }

    function updateUploadText() {
      if (!uploadText) return;
      var names = [];
      if (state.sides.front.loaded) names.push('Front: ' + state.sides.front.name);
      if (state.sides.back.loaded) names.push('Back: ' + state.sides.back.name);
      uploadText.textContent = names.length ? names.join(' • ') : defaultUploadText;
    }

    function handleFile(file) {
      showUploadError('');
      if (!file) return;
      var validTypes = ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'];
      if (validTypes.indexOf(file.type) === -1) {
        showUploadError('Unsupported file type. Please upload a PNG, JPG, WEBP or SVG image.');
        return;
      }
      if (file.size > maxFileSizeMB * 1024 * 1024) {
        showUploadError('File is too large. Maximum size is ' + maxFileSizeMB + 'MB.');
        return;
      }
      var reader = new FileReader();
      reader.onload = function (e) {
        var s = side();
        s.loaded = true;
        s.src = e.target.result;
        s.name = file.name;
        s.scale = 0.45;
        s.x = 0.5;
        s.y = 0.35;
        updateUploadText();
        renderDesigns();
      };
      reader.readAsDataURL(file);
    }

    if (uploadInput) {
      uploadInput.addEventListener('change', function () {
        handleFile(uploadInput.files[0]);
      });
    }

    if (uploadZone) {
      ['dragenter', 'dragover'].forEach(function (evt) {
        uploadZone.addEventListener(evt, function (e) {
          e.preventDefault();
          uploadZone.classList.add('is-dragover');
        });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        uploadZone.addEventListener(evt, function (e) {
          e.preventDefault();
          uploadZone.classList.remove('is-dragover');
        });
      });
      uploadZone.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files.length) {
          handleFile(e.dataTransfer.files[0]);
        }
      });
    }

    if (scaleInput) {
      scaleInput.addEventListener('input', function () {
        side().scale = parseInt(scaleInput.value, 10) / 100;
        renderDesigns();
      });
    }

    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        state.sides[state.activeSide] = blankSide();
        if (uploadInput) uploadInput.value = '';
        showUploadError('');
        updateUploadText();
        renderDesigns();
      });
    }

    garmentViews.forEach(function (view) {
      view.querySelectorAll('[data-design-layer]').forEach(function (layer) {
        var img = layer.querySelector('[data-design-image]');
        if (!img) return;
        var dragging = false;

        img.addEventListener('pointerdown', function (e) {
          var s = state.sides[layer.dataset.side];
          if (!s || !s.loaded) return;
          dragging = true;
          layer.classList.add('is-dragging');
          img.setPointerCapture(e.pointerId);
          e.preventDefault();
        });

        img.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          var s = state.sides[layer.dataset.side];
          var rect = layer.getBoundingClientRect();
          s.x = Math.min(0.98, Math.max(0.02, (e.clientX - rect.left) / rect.width));
          s.y = Math.min(0.98, Math.max(0.02, (e.clientY - rect.top) / rect.height));
          renderDesigns();
        });

        ['pointerup', 'pointercancel'].forEach(function (evt) {
          img.addEventListener(evt, function () {
            dragging = false;
            layer.classList.remove('is-dragging');
          });
        });
      });
    });

    updateGarmentField();
    applyColor();
    setSide('front');
  }

  function initAll() {
    document.querySelectorAll('[data-custom-printing]').forEach(initCustomPrinting);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-custom-printing]');
    if (root) {
      root.dataset.cpInitialized = 'false';
      initCustomPrinting(root);
    }
  });
})();
